import { Box } from "@mui/material";
import { CircularProgressbar, buildStyles } from "react-circular-progressbar";
import "react-circular-progressbar/dist/styles.css";

const VendorProfileWithCompletion = ({
  completion = 0,
  size = 35,
  textSize = "25px",
  trailColor = "#d6d6d6",
  progressColor, // Optional custom progress color
  textColor = "#FFFFFF", // Default text color
}) => {
  const getColor = () => {
    if (progressColor) return progressColor;
    if (completion < 40) return "#ff4d4d";
    if (completion < 70) return "#ffa500";
    return "#CFD31D";
  };

  return (
    <Box display="flex" alignItems="center" gap={2}>
      <Box width={size} height={size}>
        <CircularProgressbar
          value={completion}
          text={`${completion}%`}
          styles={buildStyles({
            textColor,
            pathColor: getColor(),
            trailColor,
            textSize,
            strokeLinecap: "round",
          })}
        />
      </Box>
    </Box>
  );
};

export default VendorProfileWithCompletion;
